import { render, staticRenderFns } from "./liftInfo.vue?vue&type=template&id=56046a9a&scoped=true&"
import script from "./liftInfo.vue?vue&type=script&lang=js&"
export * from "./liftInfo.vue?vue&type=script&lang=js&"
import style0 from "./liftInfo.vue?vue&type=style&index=0&id=56046a9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56046a9a",
  null
  
)

export default component.exports